import { User } from 'app/user';
import { SessionSurvey } from './session-survey.model';
import { SESSION_STATUS } from './session-status.const';

export class Session {
  constructor(
    private id: SessionId,
    public name: string,
    public status: string,
    public type: string,
    public deletable: boolean,
    public startDate: Date,
    public endDate: Date,
    public sessionItem: SessionSurvey[],
    public coaches: User[],
    public participants?: User[]
  ) { }

  public getId(): SessionId {
    return this.id;
  }

  public isActive(): boolean {
    return SESSION_STATUS.PENDING === this.status;
  }
}

export type SessionId = string;



// WEBPACK FOOTER //
// /dist/src/app/session/session.model.ts